'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FlexView = require('./FlexView');

var _FlexView2 = _interopRequireDefault(_FlexView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FlexView2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-flexview/lib/index.js
// module id = 458
// module chunks = 0